export const AP = 'ap';
export const PRE_AP = 'preap';
export const SPRINGBOARD = 'springboard';
